import { useState } from "react";
const description = "Floating laptop, tablet, and camera-equipped phone displaying Darren's portfolio across three screen sizes, connected by luminous orbits";
export default function SculpturePoster() {
    const [fallback, setFallback] = useState(false);
    if (!fallback)
        return (<img className="sculpture-poster" src="/images/devices-iris.webp" width="1380" height="1054" alt={description} onError={() => setFallback(true)}/>);
    return (<svg className="sculpture-poster" viewBox="0 0 690 526" fill="none" role="img" aria-label={description}>
      <ellipse cx="345" cy="265" rx="298" ry="135" stroke="#b8a3f0" opacity=".6" transform="rotate(-15 345 265)"/>
      <g transform="rotate(-9 140 210)">
        <rect x="55" y="55" width="160" height="290" rx="14" fill="#151a25" stroke="#9babc2" strokeWidth="3"/>
        <rect x="65" y="70" width="140" height="260" rx="6" fill="#100d18"/>
        <circle cx="135" cy="63" r="3" fill="#729bc9"/>
        <path d="M80 97h85m-85 13h67" stroke="#c5b5f2" strokeWidth="6"/>
        <rect x="80" y="137" width="110" height="99" rx="3" fill="#d8dacf"/>
        <path d="M80 254h76m-76 12h48" stroke="#747080" strokeWidth="4"/>
        <rect x="80" y="285" width="48" height="31" fill="#29364b"/>
        <rect x="138" y="285" width="52" height="31" fill="#302540"/>
      </g>
      <g transform="rotate(8 355 285)">
        <rect x="192" y="130" width="325" height="222" rx="10" fill="#080d16" stroke="#8896ad" strokeWidth="3"/>
        <rect x="204" y="143" width="301" height="195" rx="3" fill="#100d18"/>
        <path d="M220 172h38m183 0h43" stroke="#747080" strokeWidth="3"/>
        <path d="M220 205h127m-127 17h108m-108 17h85" stroke="#ece8f4" strokeWidth="8"/>
        <path d="M272 239h47" stroke="#c5b5f2" strokeWidth="8"/>
        <rect x="372" y="198" width="112" height="100" rx="3" fill="#282136"/>
        <path d="M220 266h97m-97 8h76" stroke="#747080" strokeWidth="3"/>
        <rect x="220" y="289" width="63" height="17" fill="#c5b5f2"/>
        <path d="m190 354-65 80h455l-65-80Z" fill="#4b5364" stroke="#98a5b8"/>
        <path d="M211 370h282m-294 14h304" stroke="#1f2738" strokeWidth="9"/>
        <path d="M304 399h100l12 25H292Z" fill="#272f40"/>
      </g>
      <g transform="rotate(13 565 342)">
        <rect x="514" y="240" width="104" height="212" rx="14" fill="#080c14" stroke="#9eacbf" strokeWidth="3"/>
        <rect x="522" y="248" width="88" height="196" rx="8" fill="#100d18"/>
        <rect x="551" y="252" width="29" height="7" rx="4" fill="#03050a"/>
        <circle cx="573" cy="255" r="2" fill="#729bc9"/>
        <path d="M533 278h64m-64 11h45" stroke="#c5b5f2" strokeWidth="5"/>
        <path d="M533 311h63m-63 8h56" stroke="#747080" strokeWidth="3"/>
        <rect x="533" y="337" width="65" height="69" rx="3" fill="#d8dacf"/>
        <path d="M533 420h48" stroke="#747080" strokeWidth="3"/>
      </g>
    </svg>);
}
